import React, {useState} from 'react';
import {MeteringPoint as MeteringPointType} from '../../../models/electricity/metering-point';
import {MeteringPoint} from "./MeteringPoint"

interface MeteringPointListProps {
  meteringPoints: MeteringPointType[] | undefined;
  withProductionCapacity: boolean;
  isOffer: boolean;
}

export function MeteringPointList({
                                    meteringPoints, 
                                    withProductionCapacity,
                                    isOffer
} : MeteringPointListProps) {
  const [expand, setExpand] = useState(false);

  const meteringPointsLen = meteringPoints?.length ?? 0;
  const meteringPointsLimit = expand ? meteringPointsLen : 3

  if(!meteringPoints?.length) return null;

  return (
    <>
      <div className="u-hr"></div>
      <div className="row ml-lg-3 mb-3">
        <div className="col">
          <strong className="u-fs-20">{meteringPoints.length > 1 ? 'Tarbimiskohad' : 'Tarbimiskoht'}</strong>
        </div>
      </div>
      <div>
        <div className="row px-2 px-lg-3 mx-0 mb-2">
          <div className="d-none col-lg d-lg-flex flex-row text-gray-700">EIC</div>
          <div className="d-none col-lg d-lg-flex flex-row text-gray-700">AADRESS</div>
          {withProductionCapacity && (
            <div className="d-none col-lg d-lg-flex flex-row text-gray-700">TOOTMISVÕIMSUS (kW)</div>
          )}
        </div>
        {meteringPoints?.slice(0, meteringPointsLimit).map(mp => (
          <MeteringPoint 
            {...mp} 
            productionCapacity={isOffer ? mp.offerProductionCapacity : mp.productionCapacity}
            key={mp.eic}
            withProductionCapacity={withProductionCapacity}
          />
        ))}
        {(meteringPointsLen > 3) && (
          <div
            className="cursor-pointer u-fs-16 row align-items-center justify-content-center justify-content-lg-start ml-lg-3 mt-3"
            onClick={() => setExpand(!expand)}
          >
            <i className={expand ? "icon__arrow-up" : "icon__arrow-down"}></i>
            <strong className="text-right text-lg-left ml-2">{expand ? "Näita vähem" : "Näita rohkem"}</strong>
          </div>
        )}
      </div>
    </>
  );
}